import { gql } from '@lcs/shared/api';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const SaveActiveUserMutation = gql`
   mutation SaveActiveUser($user: UserPostInput!) {
      saveUser(user: $user) {
         userId
         isActive
      }
   }
`;
